export default __webpack_public_path__ + "static/media/logo.7b5b2176.svg";